export default {
  contractMission: {
    contractMission: {
      title: ({ plural }) => plural(["Mission", "Missions"]),
      aiProposal: "Proposition IA",
      activitiesLinked: ({ named }) => `${named("count")} activité(s) rattachée(s)`,
      levelOfAchievement: "Niveau de réalisation",
      validate: "Valider cette mission",
      decline: "Refuser",
      merge: "Fusionner dans...",
      defined: "Missions définies",
      no_missions: "Aucune mission n'est définie sur ce contrat.",
      import: "Importer la fiche de mission",
      import_from_sheet: "Commencer à en ajouter à partir d'une fiche mission",
      empty_no_sheet:
        "Aucune mission n'est définie. Importez une fiche de mission pour démarrer le suivi de l'alternant.",
      empty_no_sheet_no_ia: "Aucune mission n'est définie.",
      empty_no_sheet_cta: "Importer une fiche de mission",
      empty_has_sheet:
        "Une fiche de mission a été importée. Lancez le découpage pour transformer son contenu en missions à suivre.",
      empty_has_sheet_cta: "Lancer le découpage",
      no_ia_alert: "Définissez et suivez les missions de votre alternant/stagiaire dans cet onglet",
      no_ia_alert_description: "Ajouter une mission pour votre alternant/stagiaire",
    },
    rncpGlobalAnalysis: {
      button: "Analyse globale",
      confirm_title: "Lancer l'analyse globale ?",
      confirm_text:
        "Cette analyse donne une vue d'ensemble de la corrélation entre les missions et le référentiel de compétences visé, pour situer la progression globale de l'alternant.",
      launch: "Lancer l'analyse",
      loading_title: "Calcul de la corrélation globale avec le référentiel",
      error_title: "L'analyse n'a pas pu aboutir",
      failed: "L'analyse globale a échoué. Veuillez la relancer.",
      retry: "Relancer l'analyse",
      completed: "Analyse terminée",
      step_reading_title: "Lecture des missions",
      step_reading_subtitle: "Ensemble des missions publiées du contrat et liaisons déjà validées",
      step_matching_title: "Calcul de la corrélation globale",
      step_matching_subtitle: "Score global et couverture par bloc de compétences",
      result_title: "Résultat de l'analyse globale",
      last_analysis: "Dernière analyse : {date}",
      missions_analysed: ({ plural, named }) =>
        plural([`${named("count")} mission analysée`, `${named("count")} missions analysées`]),
      score_label: "Score de corrélation global",
      coverage_title: "Couverture par bloc de compétence",
      block_coverage_label: "{name} : {score} % de couverture",
      result_empty: "Aucun résultat d'analyse globale pour le moment.",
      rncp_title_unknown: "Référentiel non renseigné",
    },
    rncpMissionAnalysis: {
      button: "Analyse par mission",
      confirm_title: "Lancer l'analyse par mission ?",
      confirm_text:
        "Cette analyse facilite la compréhension et la cartographie des compétences développées par l'alternant dans le cadre de ses missions : elle propose des rapprochements avec le référentiel, mission après mission, que vous validez à votre rythme.",
      launch: "Lancer l'analyse",
      completed: "Analyse terminée",
      loading_title: "Comparaison des missions avec le référentiel de compétences",
      step_reading_title: "Lecture des missions",
      step_reading_subtitle: "Commentaires, niveaux de réalisation, objectifs (historique des questionnaires)",
      step_matching_title: "Comparaison avec le référentiel",
      step_matching_subtitle: "Mise en correspondance avec les blocs de compétences",
      failed: "L'analyse par mission a échoué. Veuillez la relancer.",
      error_title: "L'analyse n'a pas pu aboutir",
      retry: "Relancer l'analyse",
      result_title: "Résultat de l'analyse par mission",
      result_intro:
        "L'analyse de la relation entre missions et compétences facilite la compréhension et la cartographie des compétences développées par l'alternant dans le cadre de ses missions.",
      result_count: ({ plural, named }) => plural([`${named("count")} mission`, `${named("count")} missions`]),
      result_empty: "Aucune mission à afficher pour cette analyse.",
      mission_status_to_validate: "À valider",
      mission_status_analysed: "Analysée",
      mission_status_none: "Non analysée",
      mission_no_content: "Aucune compétence validée ni suggestion en attente pour cette mission.",
      validated_title: "Compétences validées",
      pending_title: "Suggestions IA en attente",
      validate: "Valider",
      refuse: "Refuser",
      validate_label: ({ named }) => `Valider le bloc ${named("name")}`,
      refuse_label: ({ named }) => `Refuser le bloc ${named("name")}`,
      remove_label: ({ named }) => `Retirer ${named("name")}`,
      score_value: ({ named }) => `Score de pertinence : ${named("score")} %`,
      show_detail: "Voir le détail",
      hide_detail: "Masquer le détail",
      show_detail_label: ({ named }) => `Voir le détail du bloc ${named("name")}`,
      hide_detail_label: ({ named }) => `Masquer le détail du bloc ${named("name")}`,
      detail_skills: "Compétences du bloc",
      suggestion_validated: ({ named }) => `Bloc ${named("name")} validé pour la mission ${named("mission")}`,
      suggestion_refused: ({ named }) => `Suggestion ${named("name")} refusée pour la mission ${named("mission")}`,
      category_removed: ({ named }) => `Bloc ${named("name")} retiré de la mission ${named("mission")}`,
      mission_skills_title: "Bloc de compétence lié",
      mission_skills_none: "Aucune compétence rattachée pour le moment",
      mission_skills_add_placeholder: "+ Ajouter une compétence…",
      mission_skills_info:
        "Ces actions sont enregistrées immédiatement, sans passer par le bouton « Enregistrer » de la mission.",
      mission_category_added: ({ named }) => `Bloc ${named("name")} ajouté à la mission`,
      mission_category_validated: ({ named }) => `Bloc ${named("name")} validé`,
      mission_category_refused: ({ named }) => `Suggestion ${named("name")} refusée`,
      mission_category_removed: ({ named }) => `Bloc ${named("name")} retiré de la mission`,
    },
    import: {
      title: "Découpage de la fiche de mission",
      intro: "L'IA identifie et reformule les missions de la fiche — vous choisissez celles à publier.",
      existing_sheet: "Fiche de mission",
      upload_pdf: "Déposer un PDF",
      free_text: "Ou saisir le contenu directement",
      free_text_placeholder: "Collez ou saisissez le contenu de votre fiche de mission…",
      or: "ou",
      or_replace: "ou déposer une autre fiche",
      has_file_alert: "Fiche importée depuis le dossier d'inscription",
      split_failed: "Le découpage automatique n'a pas fonctionné. Veuillez relancer le découpage.",
      launch: "Lancer le découpage",
      loading_title: "Découpage en cours...",
      loading_subtitle: "L'IA analyse et reformule les missions",
      missions_proposed: "mission(s) proposée(s)",
      validate_all: "Tout valider",
      results_actions: "Actions sur les missions proposées",
      validate: "Valider",
      edit: "Modifier",
      remove: "Supprimer",
      confirm_edit: "Confirmer la modification",
      field_name: "Nom de la mission",
      field_description: "Description de la mission",
      no_missions: "Aucune mission proposée.",
      publish: ({ named }) => `Publier ${named("count")} mission(s)`,
      publish_success: ({ named }) => `${named("count")} mission(s) publiée(s) avec succès`,
      removal_announcement: ({ named }) =>
        `Mission « ${named("name")} » supprimée. ${named("count")} mission(s) proposée(s) restante(s).`,
    },
    banner: {
      title: "Une fiche de mission a été importée depuis le dossier d'inscription",
      subtitle:
        "Découpez cette fiche en missions pour suivre la progression de l'alternant tout au long de l'alternance",
      import: "Procéder à l'import",
      import_tooltip: "Ouvrir la modale de découpage de la fiche de mission",
      later: "Plus tard",
      later_tooltip: "Masquer ce bandeau pour cette session",
    },
  },
};
